import React from "react";
import { Link } from "react-router-dom";
import topicsBackground from "../assets/images/topics_background.svg";
import PrivacyContent from "../components/legal/PrivacyContent";

const PrivacyPolicyPage: React.FC = () => {
  return (
    <div className="min-h-screen relative pb-6 bg-gradient-to-b from-electrum-100 via-white to-white">
      {/* Fixed Background Image */}
      <div
        className="fixed inset-0 z-0 top-8"
        style={{
          backgroundImage: `url(${topicsBackground})`,
          backgroundSize: "cover",
          backgroundPosition: "center top",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed",
        }}
      />
      <div className="relative max-w-5xl mx-auto px-4 py-4 my-10 bg-white rounded-lg shadow-lg">
        <div className="space-y-6 text-gray-800">
          <header>
            <h1 className="text-3xl font-bold mb-2">
              Psych for Life<sup>®</sup> Privacy Notice
            </h1>
            <PrivacyContent showLastUpdated={true} />
          </header>
        </div>
        <div className="mt-8 pt-6 border-t border-gray-200">
          <Link
            to="/legal"
            className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium"
          >
            ← Back to Legal and Privacy Policy
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
